// การแปลงมุมมอง (homography) จากพิกัดบนกระดาษ (มม.) ไปเป็นพิกัดบนภาพ (พิกเซล)
// ด้วยจุดคู่กัน 4 จุด (ศูนย์กลางสี่เหลี่ยมมุมกระดาษ) — รองรับกระดาษเอียง ย่อ/ขยาย
// และภาพที่ถ่ายเฉียงเล็กน้อย ซึ่งการเลื่อน+หมุนธรรมดาทำไม่ได้

// แก้ระบบสมการเชิงเส้น n x n ด้วย Gaussian elimination + partial pivoting
const solve = (A, b) => {
  const n = b.length
  const M = A.map((row, i) => [...row, b[i]])
  for (let col = 0; col < n; col++) {
    let pivot = col
    for (let r = col + 1; r < n; r++) {
      if (Math.abs(M[r][col]) > Math.abs(M[pivot][col])) pivot = r
    }
    if (Math.abs(M[pivot][col]) < 1e-12) return null
    ;[M[col], M[pivot]] = [M[pivot], M[col]]
    for (let r = 0; r < n; r++) {
      if (r === col) continue
      const f = M[r][col] / M[col][col]
      for (let c = col; c <= n; c++) M[r][c] -= f * M[col][c]
    }
  }
  return M.map((row, i) => row[n] / row[i])
}

// src/dst = [[x, y] x 4] คืนฟังก์ชัน (x, y) -> [x', y'] หรือ null เมื่อจุดเรียงตัวเสื่อม (เช่น 3 จุดอยู่บนเส้นเดียวกัน)
export const homography = (src, dst) => {
  const A = []
  const b = []
  for (let i = 0; i < 4; i++) {
    const [x, y] = src[i]
    const [u, v] = dst[i]
    A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u)
    A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v)
  }
  const h = solve(A, b)
  if (!h) return null
  const [a, bb, c, d, e, f, g, k] = h
  return (x, y) => {
    const w = g * x + k * y + 1
    return [(a * x + bb * y + c) / w, (d * x + e * y + f) / w]
  }
}
